/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../components/ui-elements/table/StyledTableRow';
import { FormControl, Grid, InputLabel, MenuItem, Select, Tooltip } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRouterUserList } from '../../../../../store/reducers/router/routerAction';
import RouterUserCreation from './routerCreationUser';
import DeleteRouterUser from './DeleteRouterUser';

const RouterUsers = () => {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const users = useSelector(state => state.router.routerUsers);
    const [routerName, setRouterName] = useState("Router1");

    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllRouterUserList({ "routerName": routerName })).unwrap();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [routerName, dispatch]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return (
        <>
            {!loading ? <>
                <Grid container justify="center">
                    <Grid xs={12} sm={6} md={6} style={{ marginBottom: '20px' }}>
                        <FormControl fullWidth  >

                            <InputLabel htmlFor="outlined-Type">Router</InputLabel>

                            <Select
                                value={routerName}
                                variant="outlined"
                                name="routerName"
                                label="Router"
                                style={{ color: 'white' }}
                                onChange={(e) => setRouterName(e.target.value)}
                            >
                                <MenuItem value='Router1'>
                                    Router1
                                </MenuItem>
                                <MenuItem value='Router2'>
                                    Router2
                                </MenuItem>
                                <MenuItem value='Conductor'>
                                    Conductor
                                </MenuItem>

                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid xs={12} sm={6} md={6} style={{ marginBottom: '20px' }}>
                        <RouterUserCreation routerName={routerName} />
                    </Grid>
                    <Grid xs={12} sm={12} md={12}>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell label="Name" />
                                        <StyledTableCell label="Full Name" />
                                        <StyledTableCell label="Enabled" />
                                        <StyledTableCell label="" />

                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(users) && users.length > 0 && users.map((row) => (
                                        <React.Fragment key={row.name}>

                                            <StyledTableRow >
                                                <StyledTableCell label={row?.name} />
                                                <StyledTableCell label={row?.fullName} />
                                                <StyledTableCell label={row?.enabled ? "true" : "false"} />
                                                <StyledTableCell>
                                                    <Tooltip title="Delete User">
                                                        <span>
                                                            <DeleteRouterUser routerName={routerName} name={row.name} />
                                                        </span>
                                                    </Tooltip>

                                                </StyledTableCell>

                                            </StyledTableRow>
                                        </React.Fragment>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </> : (<Loader />)}

        </>
    )

}

export default RouterUsers;
